export var DROPDOWN_DIRECTION_LEFT = 'left';
export var DROPDOWN_DIRECTION_RIGHT = 'right';
export var DROPDOWN_DIRECTION_OPTIONS = [DROPDOWN_DIRECTION_LEFT, DROPDOWN_DIRECTION_RIGHT];